export const ACC_CONN_SUMMARY_LOAD_SAGA = 'ACC_CONN_SUMMARY_LOAD_SAGA'
export const accountConnectionsSummaryLoad = accountId => ({
  type: ACC_CONN_SUMMARY_LOAD_SAGA,
  accountId
})

export const ACC_CONN_SUMMARY_LOADED = 'ACC_CONN_SUMMARY_LOADED'
export const accountConnectionsSummaryLoaded = accountConnectionsSummary => ({
  type: ACC_CONN_SUMMARY_LOADED,
  accountConnectionsSummary
})

export const ACC_CONN_SUMMARY_LOAD_FAILURE = 'ACC_CONN_SUMMARY_LOAD_FAILURE'
export const accountConnectionsSummaryLoadFailure = error => ({
  type: ACC_CONN_SUMMARY_LOAD_FAILURE,
  error
})
